angular.module('dpw.services').factory('botNameConfigurationService', ['$q', 'api', function ($q, api) {
    return {
        botNameRegex: /^(\s|\d|[a-zA-Z]|\.|\-|_)+$/,
        get: get,
        save: save,
        allowConfigure: allowConfigure,
        disallowConfigure: disallowConfigure
    };

    function get(appId) {
        return $q(function (resolve) {
            api.call(api.botProvision.botName.get({appId: appId}), function (data) {
                resolve(data);
            });
        });
    }

    function save(appId, botName) {
        return $q(function (resolve, reject) {
            api.call(api.botProvision.botName.save({
                appId: appId,
                data: {botName: botName}
            }), function (data) {
                resolve(data);
            }, function (err, defaultHandler) {
                reject({
                    err: err,
                    defaultHandler: defaultHandler
                });
            });
        });
    }

    function allowConfigure(appId) {
        return $q(function (resolve) {
            api.call(api.botProvision.botName.allowConfigure({appId: appId}), function (data) {
                resolve(data);
            });
        });
    }

    function disallowConfigure(appId) {
        return $q(function (resolve) {
            api.call(api.botProvision.botName.disallowConfigure({appId: appId}), function (data) {
                resolve(data);
            });
        });
    }
}]);
